// Shared admin date formatting — messages are listed/read by staff scanning
// a table, so a compact absolute date+time (not a relative "3 hours ago")
// keeps every row unambiguous regardless of when it's viewed.
export const formatDate = (iso: string): string =>
  new Date(iso).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
